import { BeforeProcessEndEventPayload } from '@mwe/features/wizard';
import { map, Observable, of, take, tap } from 'rxjs';
import { inject, Injector } from '@angular/core';
import { PopupService } from '@mwe/services';
import { IPopupModelV2 } from '@mwe/models';
import { Router } from '@angular/router';
import { ROUTE_UMMELDUNG_BESTAETIGUNG, ROUTE_UMMELDUNG_FILE_UPLOAD } from '../../../app.constants';
import { UmmeldungSavePopupComponent } from '../components/popup/ummeldung-save-popup.component';
import { UmmeldungWizardService } from '../ummeldung.wizard.service';
import { mapExitPopupResultToDecision, UMMELDUNG_EXIT_POPUP_RESULT, UmmeldungExitPopupDecision } from './exit-popup-decision';

/**
 * Hook for `withConfirmExit`. Contract of the returned observable: emit `true` to PREVENT the
 * exit (stay in the wizard), `false` to allow it.
 */
function ummeldungCustomConfirmExitDialog(event: BeforeProcessEndEventPayload): Observable<boolean> {
  const ummeldungWizardService = inject(UmmeldungWizardService);
  if (event.reason === 'finished') {
    return of(false);
  }
  if (ummeldungWizardService.consumeNextExitConfirmationBypass()) {
    return of(false);
  }
  if (inject(Router).url.includes(ROUTE_UMMELDUNG_BESTAETIGUNG) || inject(Router).url.includes(ROUTE_UMMELDUNG_FILE_UPLOAD)) {
    return of(false);
  }
  if (!ummeldungWizardService.touchAndValidateCurrentStep()) {
    return of(true);
  }
  openUmmeldungExitPopup();
  return observeExitPopupDecision().pipe(map(decision => decision === UMMELDUNG_EXIT_POPUP_RESULT.stay));
}

function closeWithCustomConfirmExitDialog(): Observable<UmmeldungExitPopupDecision> {
  const ummeldungWizardService = inject(UmmeldungWizardService);
  if (!ummeldungWizardService.touchAndValidateCurrentStep()) {
    return of(UMMELDUNG_EXIT_POPUP_RESULT.stay);
  }

  openUmmeldungExitPopup();

  return observeExitPopupDecision().pipe(
    tap(decision => {
      if (decision !== UMMELDUNG_EXIT_POPUP_RESULT.stay) {
        ummeldungWizardService.closeWithoutExitConfirmation();
      }
    }),
  );
}

function observeExitPopupDecision(): Observable<UmmeldungExitPopupDecision> {
  return inject(PopupService).events().pipe(take(1), map(mapExitPopupResultToDecision));
}

function openUmmeldungExitPopup(): void {
  const UMMELDUNG_EXIT_POPUP: IPopupModelV2 = {
    id: 'ummeldung-confirm-exit',
    modalSize: 'md',
    component: UmmeldungSavePopupComponent,
    titleKey: 'ummeldung.confirmExitPopup.title',
    componentData: {
      messageKey: 'ummeldung.confirmExitPopup.description',
      iconColorClass: 'blue',
      iconTypeClass: 'fas fa-solid fa-question',
    },
    dismissable: false,
    modalOpts: { injector: inject(Injector) },
  };

  const popupService = inject(PopupService);
  popupService.openV2(UMMELDUNG_EXIT_POPUP);
}

export { ummeldungCustomConfirmExitDialog, closeWithCustomConfirmExitDialog };
